import styled from "styled-components";
import MsgBoxSelect from "../MsgBoxSelect/msg-box-select.component";

export const Inboxes = styled(MsgBoxSelect)`
	margin-bottom: 30px;
	margin-top: 50px;
	width: 40%;
	margin-left: 10px;
`;
